import type {
	PlateValue,
	QuoteFont,
	QuoteRollup,
	QuoteSection,
	QuoteSectionType,
	QuoteTemplate,
	QuoteTheme,
} from '../resolver/types';

/** The designer's current payload shape. Nothing was ever persisted in an older one. */
export const CURRENT_SCHEMA_VERSION = 1;

export const SECTION_TYPES: readonly QuoteSectionType[] = ['INTRODUCTION', 'SCOPE', 'TERMS'];
export const THEMES: readonly QuoteTheme[] = ['modern', 'classic', 'minimal'];
export const FONTS: readonly QuoteFont[] = ['helvetica', 'times', 'courier'];
export const ROLLUPS: readonly QuoteRollup[] = ['roles', 'phase', 'deliverable', 'project'];

export const sectionOf = (template: QuoteTemplate, type: QuoteSectionType): QuoteSection | undefined =>
	template.sections.find(section => section.type === type);

/** Returns a new template with one section patched; array order is preserved and nothing is mutated. */
export const withSection = (template: QuoteTemplate, type: QuoteSectionType, patch: Partial<QuoteSection>): QuoteTemplate => ({
	...template,
	sections: template.sections.map(section => (section.type === type ? {...section, ...patch} : section)),
});

/** Whether a section is switched on. A section the payload does not carry reads as off. */
export const sectionEnabled = (template: QuoteTemplate, type: QuoteSectionType): boolean =>
	sectionOf(template, type)?.enabled === true;

/** A section's authored body, or an empty document when the payload does not carry the section. */
export const sectionBody = (template: QuoteTemplate, type: QuoteSectionType): PlateValue =>
	sectionOf(template, type)?.body ?? [];
